var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.uploadtype == "fileurl"
    ? _c(
        "el-upload",
        {
          ref: "upload",
          attrs: {
            uploadfile: "",
            single: "",
            action: _vm.uploadUrl,
            accept: _vm.accept,
            "auto-upload": false,
            "file-list": _vm.filelist,
            "on-exceed": _vm.onExceed,
            "on-change": _vm.handleChange,
            "on-remove": _vm.handleRemove
          }
        },
        [
          _c("el-button", { attrs: { size: "small", type: "primary" } }, [
            _vm._v(_vm._s(_vm.btntext))
          ]),
          _vm._v(" "),
          _vm.showtips
            ? _c("div", {
                staticClass: "el-upload__tip",
                attrs: { slot: "tip" },
                domProps: { textContent: _vm._s(_vm.getTips()) },
                slot: "tip"
              })
            : _vm._e()
        ],
        1
      )
    : _vm.uploadtype == "filelist"
    ? _c(
        "el-upload",
        {
          attrs: {
            "file-list": _vm.filelist,
            drag: "",
            uploadfile: "",
            multiple: "",
            limit: Number(_vm.maxlength),
            action: _vm.uploadUrl,
            "on-exceed": _vm.onExceed,
            "on-change": _vm.handleChange,
            "on-remove": _vm.handleRemove
          }
        },
        [
          _c("i", { staticClass: "el-icon-upload" }),
          _vm._v(" "),
          _c("div", { staticClass: "el-upload__text" }, [
            _vm._v("将文件拖到此处，或"),
            _c("em", [_vm._v("点击上传")])
          ]),
          _vm._v(" "),
          _vm.showtips
            ? _c("div", {
                staticClass: "el-upload__tip",
                attrs: { slot: "tip" },
                domProps: { textContent: _vm._s(_vm.getTips()) },
                slot: "tip"
              })
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18d6211a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18d6211a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyInputFile.vue
// module id = YNy1
// module chunks = 38